import { render, staticRenderFns } from "./PageBreadcrumb.vue?vue&type=template&id=484e11c9&"
import script from "./PageBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./PageBreadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./PageBreadcrumb.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports